export const RPH = 'Rph';
export const SET_TICKET = 'SET_TICKET';
export const SET_BUYER = 'SET_BUYER';
export const SET_PASSENGERS = "SET_PASSENGERS";
export const SET_BUYER_PASSENGERS = "SET_BUYER_PASSENGERS";
export const TICKET_PRICE = "TICKET_PRICE";
export const RESERVE_TICKET = "RESERVE_TICKET";
export const SET_ISSUE = "SET_ISSUE";
export const REMOVE_TICKET = "REMOVE_TICKET";
export const SET_PAYMENT = "SET_PAYMENT";
export const REVIEW_TICKET = "REVIEW_TICKET";
export const RESERVE_SUCCESSFUL = "RESERVE_SUCCESSFUL";
export const GO_BACK = "GO_BACK";
export const RESERVED_TICKET = "RESERVED_TICKET";
export const SET_BUS_TICKET = "SET_BUS_TICKET";
export const SET_BUS_ISSUE = "SET_BUS_ISSUE";



export function setBusTicket(item) {
    setRPH(item.rph);
    return {
        type: SET_BUS_TICKET,
        BusTicket: item
    };
}
export function setTicket(orgTicket, ticket, adultNo, childNo, infantNo) {
    setRPH(ticket.airItineraryRph);
    return {
        type: SET_TICKET,
        orgTicket,
        ticket,
        adultNo,
        childNo,
        infantNo
    };
}
export function reviewTicket(data, rev_passengers) {
    return {
        type: REVIEW_TICKET,
        data,
        rev_passengers
    }
}
export function goBackPassengers(goback) {
    return {
        type: GO_BACK,
        goback
    }
}
export function setReserve(reserve) {
    return {
        type: RESERVED_TICKET,
        reserve
    }
}
export function setBusIssue(ticket) {
    return {
        type: SET_BUS_ISSUE,
        BusIssue: ticket
    }
}
export function successfulReserve(id) {
    return {
        type: RESERVE_SUCCESSFUL,
        id
    }
}

export function setBuyer(buyer) {
    return {
        type: SET_BUYER,
        buyer
    };
}
export function setPassenger(passengers) {
    return {
        type: SET_PASSENGERS,
        passengers//array
    };
}
export function setBuyerAndPassenger(user, traveller) {
    return {
        type: SET_PASSENGERS,
        user,
        traveller
    };
}
export function setTicketPrice(priceObj) {
    return {
        type: TICKET_PRICE,
        priceObj
    };
}
export function setReserveInfo(bookObj) {
    return {
        type: RESERVE_TICKET,
        bookObj
    };
}
export function setIssue(tickets) {
    return {
        type: SET_ISSUE,
        tickets
    };
}
export function setPayment(paymentObj) {
    return {
        type: SET_PAYMENT,
        paymentObj
    };
}
export function removeTicket() {
    removeRPH();
    return {
        type: REMOVE_TICKET,
    };
}


export function setRPH(rph) {
    localStorage.setItem(RPH, rph);
}

export function removeRPH() {
    localStorage.removeItem(RPH);
}

export function loadRPH() {
    return localStorage.getItem(RPH);
}







// WEBPACK FOOTER //
// ./src/redux/actions/ticket.js